import type { JobRating as JobRatingValue } from "../../lib/types/models";

/**
 * Replaces "Message the customer" once a job is completed — messaging is
 * closed at that point, so the rating the homeowner left (if any) takes its
 * place. Markup mirrors the per-job review card on ProfileScreen, minus the
 * anonymised job-id heading (the contractor already knows which job this is).
 */
export function JobRating({ rating }: { rating?: JobRatingValue }) {
  if (!rating) {
    return <p className="muted">Not rated yet.</p>;
  }
  return (
    <div className="stack stack--tight">
      <span>
        <span className="amount">{rating.rating.toFixed(1)}</span>{" "}
        <span className="muted">out of 5</span>
      </span>
      {rating.comment ? <p>{rating.comment}</p> : <p className="muted">No comment left.</p>}
    </div>
  );
}
